import {nativeBridge} from "../Bridge_Native.js";

/** Returns the passed-in text, eg. for wrapping with a console.log call. */
export function ShowToast(text: string, duration = "long" as "short" | "long", position = "bottom" as "top" | "center" | "bottom") {
	nativeBridge.Call("ShowToast", {text, duration, position});
	return text;
}

export function ShowToastAndLog(text: string, duration = "long" as "short" | "long", position = "bottom" as "top" | "center" | "bottom") {
	console.log(text);
	return ShowToast(text, duration, position);
}